module.exports = __webpack_public_path__ + "img/work-schedule.0e02f1d2.svg";